import React from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft, Shield, Lock, FileText } from 'lucide-react';

const LegalPages = ({ type }) => {
  const pages = {
    mentions: {
      title: "Mentions légales",
      icon: FileText,
      content: [
        {
          title: "Éditeur du site",
          content: "Ce site est édité par Angèle Rosalie, sage-femme libérale exerçant en profession libérale."
        },
        {
          title: "Identification professionnelle",
          content: "Angèle Rosalie - Sage-femme libérale\nTéléphone : 06 21 30 68 56\nEmail : angelerosalie.sf@proton.me\nZone d'intervention : Grand Annecy (Annecy, Seynod, Annecy-le-Vieux, Metz-Tessy, Pringy)\n\nFormation : Diplôme d'État de Sage-femme\nOrganisation professionnelle : Adhérente de l'Organisation Nationale Syndicale des Sages-femmes\n\nSpécialités :\n- Accouchement physiologique en plateau technique\n- Suivi de grossesse et préparation à la naissance\n- Suivi post-partum et accompagnement allaitement\n- Sensibilisation aux perturbateurs endocriniens\n- Surveillance de l'ictère"
        },
        {
          title: "Hébergement",
          content: "Ce site est hébergé par Vercel Inc.\nAdresse : 340 S Lemon Ave #4133, Walnut, CA 91789, États-Unis\nSite web : https://vercel.com\n\nLe site est déployé sur la plateforme Vercel qui garantit une haute disponibilité et des performances optimales."
        },
        {
          title: "Développement du site",
          content: "Site développé par Souleymane\nContact développeur : 06 09 47 64 76\n Email : babatambadou@gmail.com \n\nTechnologies utilisées :\n- React 19\n- Tailwind CSS\n- Framer Motion\n- Node.js\n- Vercel (déploiement)"
        },
        {
          title: "Propriété intellectuelle",
          content: "L'ensemble de ce site relève de la législation française et internationale sur le droit d'auteur et la propriété intellectuelle. Tous les droits de reproduction sont réservés, y compris pour les documents téléchargeables et les représentations iconographiques et photographiques.\n\nLes marques et logos reproduits sur ce site sont déposés par les sociétés qui en sont propriétaires.\n\nToute reproduction, représentation, modification, publication, adaptation de tout ou partie des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite, sauf autorisation écrite préalable."
        },
        {
          title: "Responsabilité",
          content: "Les informations contenues sur ce site sont aussi précises que possible et le site est périodiquement remis à jour, mais peut toutefois contenir des inexactitudes, des omissions ou des lacunes. Si vous constatez une lacune, erreur ou ce qui parait être un dysfonctionnement, merci de bien vouloir le signaler par email.\n\nL'utilisation des informations et contenus disponibles sur l'ensemble du site se fait sous l'entière responsabilité de l'utilisateur. Ce dernier assume la pleine responsabilité des conséquences pouvant découler de l'utilisation de ces informations et contenus."
        },
        {
          title: "Liens externes",
          content: "Ce site peut contenir des liens vers d'autres sites web. Angèle Rosalie n'exerce aucun contrôle sur ces sites et décline toute responsabilité quant à leur contenu ou leur politique de confidentialité."
        },
        {
          title: "Cookies et technologies de suivi",
          content: "Ce site utilise des cookies techniques nécessaires à son fonctionnement. Aucun cookie de suivi publicitaire n'est utilisé.\n\nLes cookies utilisés :\n- Cookies de session pour le fonctionnement du site\n- Cookies de préférences utilisateur\n\nVous pouvez configurer votre navigateur pour refuser les cookies, mais cela peut affecter le fonctionnement du site."
        },
        {
          title: "Droit applicable et juridiction",
          content: "Le présent site est soumis au droit français. En cas de litige, les tribunaux français seront seuls compétents.\n\nConformément à la loi n° 2004-575 du 21 juin 2004 pour la confiance dans l'économie numérique, les tribunaux français sont compétents pour connaître du contentieux lié à l'utilisation du site."
        },
        {
          title: "Contact et réclamations",
          content: "Pour toute question relative aux présentes mentions légales ou pour signaler un dysfonctionnement :\n\nEmail : angelerosalie.sf@proton.me\nTéléphone : 06 21 30 68 56\n\nDélai de réponse : 48h ouvrées maximum"
        }
      ]
    },
    confidentialite: {
      title: "Politique de confidentialité",
      icon: Lock,
      content: [
        {
          title: "Responsable du traitement",
          content: "Angèle Rosalie, sage-femme libérale, est responsable du traitement des données personnelles collectées via ce site web.\n\nContact : angelerosalie.sf@proton.me\nTéléphone : 06 21 30 68 56"
        },
        {
          title: "Collecte des données",
          content: "Les données personnelles collectées sur ce site sont uniquement celles que vous nous communiquez volontairement via :\n- Le formulaire de contact\n- Les demandes de rendez-vous\n- Les communications par email\n\nAucune donnée personnelle n'est collectée à votre insu. Ce site n'utilise pas de cookies de suivi publicitaire."
        },
        {
          title: "Types de données collectées",
          content: "Les données collectées peuvent inclure :\n- Nom et prénom\n- Adresse email\n- Numéro de téléphone\n- Date de naissance (pour le suivi médical)\n- Informations relatives à votre grossesse (avec votre consentement)\n- Messages et communications\n\nCes données sont collectées uniquement avec votre consentement explicite."
        },
        {
          title: "Finalités du traitement",
          content: "Vos données personnelles sont traitées pour :\n- Répondre à vos demandes de contact\n- Planifier et gérer vos rendez-vous\n- Assurer votre suivi médical (avec votre consentement)\n- Respecter les obligations légales et réglementaires\n- Améliorer la qualité des services proposés\n\nAucune donnée n'est utilisée à des fins commerciales ou marketing."
        },
        {
          title: "Base légale du traitement",
          content: "Le traitement de vos données personnelles est basé sur :\n- Votre consentement explicite pour les données de contact\n- L'exécution du contrat de soins pour les données médicales\n- Le respect des obligations légales pour la conservation des dossiers médicaux\n- L'intérêt légitime pour l'amélioration des services"
        },
        {
          title: "Conservation des données",
          content: "Vos données sont conservées :\n- Données de contact : 3 ans après le dernier contact\n- Dossiers médicaux : 20 ans minimum (obligation légale)\n- Données de facturation : 10 ans (obligation fiscale)\n\nLes données sont supprimées automatiquement à l'expiration des délais légaux."
        },
        {
          title: "Partage des données",
          content: "Vos données personnelles ne sont jamais partagées avec des tiers, sauf :\n- Avec votre consentement explicite\n- En cas d'urgence médicale (médecins, hôpitaux)\n- Pour respecter une obligation légale\n- Avec les autorités compétentes si requis par la loi\n\nAucune donnée n'est vendue ou transmise à des fins commerciales."
        },
        {
          title: "Vos droits (RGPD)",
          content: "Conformément au RGPD, vous disposez des droits suivants :\n- Droit d'accès : connaître les données vous concernant\n- Droit de rectification : corriger les données inexactes\n- Droit d'effacement : demander la suppression de vos données\n- Droit à la limitation : restreindre le traitement\n- Droit à la portabilité : récupérer vos données\n- Droit d'opposition : vous opposer au traitement\n\nPour exercer ces droits : angelerosalie.sf@proton.me"
        },
        {
          title: "Sécurité des données",
          content: "Des mesures de sécurité sont mises en place :\n- Chiffrement des communications (HTTPS)\n- Stockage sécurisé des données\n- Accès restreint aux données personnelles\n- Formation du personnel aux bonnes pratiques\n- Sauvegardes régulières et sécurisées\n\nEn cas de violation de données, vous serez informé dans les 72h."
        },
        {
          title: "Cookies et technologies de suivi",
          content: "Ce site utilise uniquement des cookies techniques nécessaires :\n- Cookies de session pour le fonctionnement\n- Cookies de préférences utilisateur\n- Aucun cookie publicitaire ou de suivi\n\nVous pouvez configurer votre navigateur pour refuser les cookies."
        },
        {
          title: "Réclamations",
          content: "Si vous estimez que vos droits ne sont pas respectés, vous pouvez :\n1. Me contacter directement : angelerosalie.sf@proton.me\n2. Saisir la CNIL : https://www.cnil.fr\n3. Porter plainte auprès des autorités compétentes\n\nDélai de réponse : 48h ouvrées maximum"
        }
      ]
    },
    cgu: {
      title: "Conditions Générales d'Utilisation",
      icon: Shield,
      content: [
        {
          title: "Objet et champ d'application",
          content: "Les présentes Conditions Générales d'Utilisation (CGU) régissent l'utilisation du site web d'Angèle Rosalie, sage-femme libérale.\n\nElles s'appliquent à tous les utilisateurs du site, qu'ils soient simples visiteurs ou patients.\n\nL'utilisation du site implique l'acceptation pleine et entière des présentes CGU."
        },
        {
          title: "Services proposés",
          content: "Ce site présente les services de sage-femme libérale suivants :\n- Suivi de grossesse et préparation à la naissance\n- Accouchement physiologique en plateau technique\n- Suivi post-partum et accompagnement allaitement\n- Sensibilisation aux perturbateurs endocriniens\n- Surveillance de l'ictère\n\nZone d'intervention : Grand Annecy (Annecy, Seynod, Annecy-le-Vieux, Metz-Tessy, Pringy)"
        },
        {
          title: "Utilisation du site",
          content: "Le site est destiné à :\n- Informer sur les services de sage-femme libérale\n- Permettre la prise de contact et la demande de rendez-vous\n- Fournir des informations sur la maternité et la naissance\n\nL'utilisateur s'engage à :\n- Utiliser le site conformément à sa destination\n- Ne pas porter atteinte aux droits des tiers\n- Respecter les droits de propriété intellectuelle\n- Ne pas diffuser de contenu illicite ou nuisible"
        },
        {
          title: "Informations médicales",
          content: "IMPORTANT : Les informations présentes sur ce site sont données à titre informatif uniquement.\n\nElles ne sauraient en aucun cas se substituer à :\n- Une consultation médicale personnalisée\n- Un diagnostic médical\n- Un traitement médical\n- Les conseils d'un professionnel de santé\n\nEn cas d'urgence médicale, contactez immédiatement :\n- Le 15 (SAMU)\n- Le 18 (Pompiers)\n- Votre médecin traitant\n- Les urgences de l'hôpital le plus proche"
        },
        {
          title: "Prise de rendez-vous",
          content: "La prise de rendez-vous se fait :\n- Par téléphone : 06 21 30 68 56\n- Par email : angelerosalie.sf@proton.me\n- Via le formulaire de contact du site\n\nDisponibilités :\n- Consultations : Lundi-Vendredi 09h-16h\n- Urgences : 24h/24 – 7j/7 de 37 SA à 41+6 SA\n\nLes rendez-vous sont confirmés par email ou SMS."
        },
        {
          title: "Confidentialité médicale",
          content: "Toutes les informations médicales sont protégées par le secret médical.\n\nLes données de santé sont traitées conformément au RGPD et aux obligations légales.\n\nAucune information médicale n'est partagée sans votre consentement explicite."
        },
        {
          title: "Limitation de responsabilité",
          content: "Angèle Rosalie s'efforce de fournir des informations exactes et à jour, mais ne peut garantir :\n- L'exactitude complète des informations\n- La disponibilité permanente du site\n- L'absence d'interruption de service\n\nL'utilisation du site se fait sous la responsabilité de l'utilisateur.\n\nEn aucun cas, Angèle Rosalie ne saurait être tenue responsable des dommages directs ou indirects résultant de l'utilisation du site."
        },
        {
          title: "Propriété intellectuelle",
          content: "L'ensemble du contenu du site (textes, images, vidéos, logos) est protégé par le droit d'auteur.\n\nToute reproduction, représentation, modification ou adaptation sans autorisation est interdite.\n\nLes marques et logos mentionnés sont la propriété de leurs détenteurs respectifs."
        },
        {
          title: "Liens externes",
          content: "Ce site peut contenir des liens vers d'autres sites web.\n\nAngèle Rosalie n'exerce aucun contrôle sur ces sites et décline toute responsabilité quant à :\n- Leur contenu\n- Leur politique de confidentialité\n- Leur sécurité\n- Leur disponibilité\n\nL'utilisation de ces liens se fait sous votre responsabilité."
        },
        {
          title: "Modification des CGU",
          content: "Ces conditions peuvent être modifiées à tout moment.\n\nLes modifications prennent effet dès leur publication sur le site.\n\nLes utilisateurs sont invités à consulter régulièrement les CGU.\n\nL'utilisation continue du site après modification vaut acceptation des nouvelles conditions."
        },
        {
          title: "Droit applicable et juridiction",
          content: "Les présentes CGU sont soumises au droit français.\n\nEn cas de litige, les tribunaux français seront seuls compétents.\n\nConformément à la loi n° 2004-575 du 21 juin 2004 pour la confiance dans l'économie numérique."
        },
        {
          title: "Contact",
          content: "Pour toute question relative aux présentes CGU :\n\nEmail : angelerosalie.sf@proton.me\nTéléphone : 06 21 30 68 56\n\nDélai de réponse : 48h ouvrées maximum"
        }
      ]
    }
  };

  const page = pages[type];
  if (!page) return null;

  const Icon = page.icon;

  return (
    <div className="min-h-screen bg-warm-50 pt-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="mb-8"
        >
          <div className="flex items-center mb-6">
            <motion.a
              href="/"
              whileHover={{ x: -3 }}
              className="flex items-center text-sage-600 hover:text-primary-600 transition-colors mr-4"
            >
              <ArrowLeft className="w-5 h-5 mr-2" />
              Retour au site
            </motion.a>
          </div>
          
          <div className="flex items-center mb-6">
            <div className="bg-primary-100 p-3 rounded-xl mr-4">
              <Icon className="w-8 h-8 text-primary-600" />
            </div>
            <h1 className="font-display text-4xl font-bold text-sage-800">
              {page.title}
            </h1>
          </div>
        </motion.div>

        {/* Content */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="bg-white rounded-2xl shadow-lg p-8"
        >
          <div className="space-y-8">
            {page.content.map((section, index) => (
              <motion.div
                key={section.title}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.3 + index * 0.1 }}
                className="border-b border-sage-200 pb-6 last:border-b-0"
              >
                <h2 className="font-display text-2xl font-semibold text-sage-800 mb-4">
                  {section.title}
                </h2>
                <div className="text-sage-600 leading-relaxed whitespace-pre-line">
                  {section.content}
                </div>
              </motion.div>
            ))}
          </div>

          {/* Footer */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.8 }}
            className="mt-12 pt-8 border-t border-sage-200"
          >
            <p className="text-sage-500 text-sm text-center">
              Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}
            </p>
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
};

export default LegalPages; 